export default "__VITE_ASSET__Dmd4TuT1__"